import { Controller } from "@hotwired/stimulus"

// Editor de HTML com pré-visualização ao vivo e inserção de variáveis Liquid.
// Targets:
//   source  -> textarea com o código HTML
//   preview -> iframe que renderiza o HTML
export default class extends Controller {
  static targets = ["source", "preview"]

  connect() {
    this.renderPreview()
  }

  renderPreview() {
    if (!this.hasPreviewTarget || !this.hasSourceTarget) return
    // srcdoc isola o conteúdo; variáveis Liquid aparecem cruas aqui
    // (a renderização real com dados acontece no servidor, na tela de detalhe).
    this.previewTarget.srcdoc = this.sourceTarget.value || ""
  }

  insertVariable(event) {
    event.preventDefault()
    if (!this.hasSourceTarget) return

    const variable = event.currentTarget.dataset.htmlEditorVarParam
    if (!variable) return

    const token = `{{ ${variable} }}`
    const ta = this.sourceTarget
    const start = ta.selectionStart ?? ta.value.length
    const end = ta.selectionEnd ?? ta.value.length

    ta.value = ta.value.slice(0, start) + token + ta.value.slice(end)
    const caret = start + token.length
    ta.setSelectionRange(caret, caret)
    ta.focus()
    this.renderPreview()
  }

  toggleView() {
    const code = this.element.querySelector(".ui-html-editor__code")
    const previewCol = this.element.querySelector(".ui-html-editor__preview-col")
    if (!code || !previewCol) return

    const hidden = code.classList.toggle("d-none")
    // Em modo só-visualização o preview ocupa a largura inteira
    previewCol.classList.toggle("col-lg-6", !hidden)
    previewCol.classList.toggle("col-lg-12", hidden)
  }
}